import ConversationMessageContent from "./ConversationMessageContent";
import ConversationMessageAttachments from "./ConversationMessageAttachments";
import { MessageAttachment } from "./Conversation";
import classNames from "classnames";
import { memo } from "react";

interface props {
  className?: string;
  content: string;
  contentColor?: "light" | "normal";
  format: "plain" | "html" | "markdown";
  attachments?: MessageAttachment[];
  journalEntryId?: string;
  patientLabId?: string;
  DisplayComponent?: () => React.ReactNode;
}

const ConversationMessage = ({
  className,
  content,
  contentColor,
  format,
  attachments,
  DisplayComponent,
}: props) => {
  return (
    <div
      className={classNames("tw-mb-2", className)}
      data-testid="chat-message"
    >
      <ConversationMessageContent
        messageContent={content}
        messageFormat={format}
        contentColor={contentColor}
      />
      <ConversationMessageAttachments attachments={attachments || []} />
      {DisplayComponent && <DisplayComponent />}
    </div>
  );
};

// Custom comparison function for React.memo
const areEqual = (prevProps: props, nextProps: props) => {
  return (
    prevProps.content === nextProps.content &&
    prevProps.format === nextProps.format &&
    prevProps.contentColor === nextProps.contentColor &&
    prevProps.className === nextProps.className &&
    JSON.stringify(prevProps.attachments) ===
      JSON.stringify(nextProps.attachments) &&
    prevProps.DisplayComponent === nextProps.DisplayComponent
  );
};

export default memo(ConversationMessage, areEqual);
